// extracted by mini-css-extract-plugin
var _1 = "UserProfileView-module__iconContainer--MREf0";
var _2 = "UserProfileView-module__subHeader--JwwXg";
export { _1 as "iconContainer", _2 as "subHeader" }
